import { CardContent } from "../../../../components/ui/card";
import { Avatar, AvatarImage } from "../../../../components/ui/avatar";
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/ui/table";
import dayjs from "dayjs";
import {
  MatchResultTypeEnum,
  TransactionLogStatusEnum,
  TransactionLogTypeEnum,
  DateTimeFormat,
  respEnum,
  AttachmentHistoryLogTypeEnum,
  ViewDateTimeFormat,
  TaxTypeEnum,
} from "../../../../constants/appConstant";
import { Icon } from "@iconify/react";
import { Formik } from "formik";
import { ImageFolderEnum } from "../../../../constants/appConstant";
import DialogModal from "../../../../components/partials/modal/dialogModal";
import { useNavigate } from "react-router-dom";
import { Pencil } from "lucide-react";
import { FaEye } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";


import moment from "moment";


import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import * as yup from "yup";
import { FormikInput, FormikSingleFileUpload } from "../../../../components/formik-components";
import common from "../../../../helper/common";
import toast from "react-hot-toast";
import { FaUpload, FaRedo } from "react-icons/fa";
import AdvanceTable from "../../../../components/advanceTable";
import { render } from "@testing-library/react";
import Utility from "../../../../helper/utilityHelper";


const BooingFurthurDetails = ({ booking, setShowNotes, onReceiptUpdated }) => {
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpenForReceipt, setIsModalOpenForReceipt] = useState(false);
  const [isModalOpenForPlayer, setIsModalOpenForPlayer] = useState(false);

  const handleImageClick = (attachment) => {
    setModalContent(
      <img
        src={Common.Utility.getImagePath(attachment)}
        //src={`${Common.AppConstant.imgBaseurl}${attachment}`}
        alt="Receipt Image"
        className="w-1/2 h-1/2 object-contain"
        style={{ width: "50%", height: "50%" }}
      />
    );
    setIsModalOpenForReceipt(true);
  };

  const handlePlayerImageClick = (attachment) => {
    setModalContent(
      <img
        src={Common.Utility.getImagePath(attachment)}
        alt="Player Image"
        className="w-1/2 h-1/2 object-contain"
        style={{ width: "50%", height: "50%" }}
      />
    );
    setIsModalOpenForPlayer(true);
  };

  const closeModal = () => {
    setIsModalOpenForPlayer(false);
    setIsModalOpenForReceipt(false);
  };


  const [showLogModal, setShowLogModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const handleSeeLog = (log) => {
    setSelectedLog(log);
    setShowLogModal(true);
  };

  const _renderViewLogs = ({ logs, onClose }) => {
    const columns = [
      { title: "Reason", key: "changing_reason" },
      {
        title: "Previous Receipt", type: "image", key: "previous_receipt"
        , render: (_, record) => (
          <div className="flex justify-center">
            <img
              src={Common.Utility.getImagePath(record?.previous_receipt?.path)}
              alt={record?.previous_receipt?.title || "Previous Receipt"}
              className="w-24 h-24 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => handleImageClick(record?.previous_receipt?.path)}
            />
          </div>
        ),
      },
      {
        title: "New Receipt", key: "new_receipt", type: "image"
        , render: (_, record) => (
          <div className="flex justify-center">
            <img
              src={Common.Utility.getImagePath(record?.new_receipt?.path)}
              alt={record?.new_receipt?.title || "New Receipt"}
              className="w-24 h-24 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => handleImageClick(record?.new_receipt?.path)}
            />
          </div>
        ),
      },
      {
        title: "Changed On",
        key: "createdOn",
        type: "text",
        render: (row) => Common.Utility.ConvertDate(row.createdOn)
      }
    ];

    return (
      <div className="max-h-[80vh] overflow-y-auto">
        <div className="mb-6">
          <h3 className="font-bold text-center text-xl text-gray-800 mb-2">Receipt Changing Logs</h3>
          <p className="text-center text-sm text-gray-600">History of receipt changes for this transaction</p>
        </div>

        {logs && logs.length > 0 ? (
          <div className="overflow-x-auto">
            <AdvanceTable
              data={{ data: logs }}
              columns={columns}
            />
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="text-gray-400 mb-2">
              <Icon icon="heroicons:document-text" className="w-12 h-12 mx-auto" />
            </div>
            <p className="text-gray-500">No receipt changes found</p>
          </div>
        )}

        <div className="mt-6 flex justify-end">
          <Button
            type="button"
            variant="outline"
            onClick={() => onClose(null)}
            className="px-6"
          >
            Close
          </Button>
        </div>
      </div>
    );
  };


  const [showUpdateReceipt, setShowUpdateReceipt] = useState(false);
  const [updateReceiptData, setUpdateReceiptData] = useState({
    id: null,
    type: null,
    previous_receipt: null,
  });


  const handleOpenPaymentUpdateReceipt = (transactionLog) => {
    setUpdateReceiptData({
      id: transactionLog.id,
      type: AttachmentHistoryLogTypeEnum.Booking_Payment,
      previous_receipt: transactionLog.attachment,
    });
    setShowUpdateReceipt(true);
  };

  const handleOpenDiscountUpdateReceipt = (transactionLog) => {
    setUpdateReceiptData({
      id: transactionLog.id,
      type: AttachmentHistoryLogTypeEnum.Booking_Discount,
      previous_receipt: transactionLog.attachment,
    });
    setShowUpdateReceipt(true);
  };
  const _renderUpdateReceipt = ({ type, id, previous_receipt, onClose }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
      <div className="modal-scroll-container">
        <Formik
          initialValues={{
            attachment: previous_receipt || null,
            new_receipt: null,
            changing_reason: "",
            type: type || null,
          }}
          validationSchema={yup.object({
            changing_reason: yup
              .string()
              .required("Reason is required")
              .min(3, "Reason must be at least 3 characters")
              .max(200, "Reason must be less than 200 characters")
          })}

          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={async (values, action) => {
            if (isSubmitting) return; // Prevent multiple submissions

            setIsSubmitting(true);




            let data = {
              ...values,
              transaction_log_id: id,
              type,
              previous_receipt: values.attachment,
              new_receipt: null,
              changing_reason: values.changing_reason,
            };

            // if (values.files && values.files.length > 0) {
            // const uploaded = await Common.Utility.handleFileUpload(
            //   values.files,
            //   ImageFolderEnum.transactions
            // );
            // data.new_receipt = uploaded[0].photo;
            // } 
            // else if (data.new_receipt===null) {
            //   // data.new_receipt = values.attachment;
            //   toast.error("Image is Required")
            //   setIsSubmitting(false);
            //   return;
            // }


            // if(!data.new_receipt)
            // {
            //   toast.error("New Receipt Is Required");
            // }



            const imagePath = data.files?.[0]?.path;
            if (imagePath) {
              data.new_receipt = imagePath;
            }
            if (!data.changing_reason || data.changing_reason.trim() === '') {
              toast.error(`Please enter a reason for changing the receipt`);
              setIsSubmitting(false);
              action.setSubmitting(false);
              return;
            }

            if (!data.new_receipt) {
              toast.error(`Please upload a new receipt image`);
              setIsSubmitting(false);
              action.setSubmitting(false);
              return;
            }

            if (data.files && data.files.filter((item) => !item.imageUrl).length) {
              var uploadFilePathType = ImageFolderEnum.transactions;
              data.new_receipt = (
                await Common.Utility.handleFileUpload(data.files, uploadFilePathType)
              )[0].photo;
              data.files = null;
            } else if (data.attachment) {
              data.new_receipt = data.attachment;
            }



            let response = await Common.ApiService.getInstance().request(
              "ChangeAttachment",
              data,
              "POST"
            );

            setIsSubmitting(false);
            action.setSubmitting(false);
            debugger
            if (response.status === respEnum.Success) {
              if (onClose) {
                onClose(response.data);
              }

              common.SweetAlert.alert(response.message, "success");

              // Call the callback to refresh data instead of page reload
              if (onReceiptUpdated) {
                setTimeout(() => {
                  onReceiptUpdated();
                }, 500);
              }
              // action.setSubmitting(false);

              // if (response.status === respEnum.Success) {
              //   if (onClose) {
              //     onClose(response.data);
              //   } else {
              //     // navigate("/app/bookingDetails", { replace: true });
              //     window.location.reload(); 
              //   }
              // }
            }
          }}
        >
          {(formikProps) => (
            <>
              <div className="flex flex-col gap-2">
                <FormikSingleFileUpload
                  formikProps={formikProps}
                  title="Previous Image"
                  uploadMainTxt="Upload Image"
                  uploadTxt="Max size 2 MB"
                  name="attachment"
                  viewOnly={true}
                />
              </div>

              {/* Previous Image (just show, no upload) */}
              {/* <div className="flex flex-col gap-2">
                <label className="text-sm font-medium text-gray-700">Previous Image</label>
                {formikProps.values.attachment ? (
                  <img
                    src={Common.Utility.getImagePath(formikProps.values.attachment)}
                    alt="Previous Attachment"
                    className="w-30 h-32  object-cover rounded border"
                  />
                ) : (
                  <span className="text-gray-400 text-sm">No Image</span>
                )}
              </div> */}
              <div className="flex flex-col gap-2 mt-3">
                <FormikInput
                  formikProps={formikProps}
                  name="changing_reason"
                  label="Changing Reason"
                  placeholder="Type Reason"
                  maxLength="200"
                />
              </div>


              <div className="flex flex-col gap-2 mt-3">
                <FormikSingleFileUpload
                  formikProps={formikProps}
                  title="Upload New Receipt"
                  uploadMainTxt="Upload New Receipt"
                  uploadTxt="Max size 2 MB"
                  name="new_receipt"
                />
              </div>

              <div className="mt-5 text-right flex gap-2 justify-end">
                <Button
                  type="button"
                  variant="primary"
                  onClick={() => formikProps.handleSubmit()}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <Icon icon="eos-icons:loading" className="w-4 h-4 mr-2" />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </Button>

                <Button
                  type="button"
                  variant="outline"
                  onClick={() => onClose(null)}
                  disabled={isSubmitting}
                >
                  Close
                </Button>
              </div>
            </>
          )}
        </Formik>
      </div>
    );
  };

  return (
    <div className="w-full flex flex-col  ">
      <style>
        {`
          @media (max-width: 768px) {
            .bottom-btns {
              padding: 3px 5px 0px 10px !important;
            }
            .transition-colors {
              margin-top: 3px;
              margin-bottom: 4px;
            }
            .receipt-reupload-icon {
              font-size: 14px !important;
              padding: 3px !important;
            }
          }
          @media (max-width: 480px) {
            .receipt-reupload-icon {
              font-size: 12px !important;
              padding: 2px !important;
            }
          }
          @media (min-width: 769px) {
            .receipt-reupload-icon {
              font-size: 16px !important;
              padding: 4px !important;
            }
          }
          .modal-scroll-container {
            max-height: 70vh;
            overflow-y: auto;
            padding: 1rem;
          }
          @media (max-width: 768px) {
            .modal-scroll-container {
              max-height: 60vh;
              padding: 0.75rem;
            }
          }
          @media (max-width: 480px) {
            .modal-scroll-container {
              max-height: 50vh;
              padding: 0.5rem;
            }
          }
          .logs-modal-table {
            min-width: 100%;
          }
          .logs-modal-table th {
            background-color: #f8fafc;
            font-weight: 600;
            text-align: center;
            padding: 12px 8px;
            border-bottom: 2px solid #e2e8f0;
          }
          .logs-modal-table td {
            text-align: center;
            padding: 12px 8px;
            border-bottom: 1px solid #e2e8f0;
            vertical-align: middle;
          }
          .logs-modal-table tr:hover {
            background-color: #f8fafc;
          }
        `}
      </style>
      <CardContent className="flex-1 p-0 w-full  pb-5">
        <div className="overflow-x-auto mt-5">
          <p className="font-bold text-center text-xl">Players</p>

          <Table>
            <TableHeader>
              <TableRow className="whitespace-nowrap">
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Side
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-left">
                  Player
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Is Creator
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Result
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Before Played Level
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  After Played Level
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className="[&_tr:last-child]:border-1">
              {booking?.players?.map((player) => (
                <TableRow key={player.id}>
                  <TableCell className="border-r text-center">
                    {player.side}-{player.position}
                  </TableCell>
                  <TableCell className="text-center border-default-200">
                    <div className="flex items-center gap-3 pr-4">
                      <div className="flex items-center gap-2">
                        <Avatar className=" rounded-[2px] h-8 w-8">
                          <AvatarImage
                            // src={`${Common.AppConstant.imgBaseurl}${player.playerImage ?? "noplayer-icon.jpg"
                            //   }`}
                             src={Common.Utility.getImagePath(player.playerImage ?? "noplayer-icon.jpg")}
                             onClick={()=>handlePlayerImageClick(player.playerImage)}

                          />
                          {/* <AvatarFallback>CD</AvatarFallback> */}
                        </Avatar>
                        <div className="text-sm  text-default-600 capitalize truncate max-w-[160px]">
                          {player.playerName}
                        </div>
                      </div>
                    </div>
                  </TableCell>

                  <TableCell className="border-default-200 text-center">
                    {player.iscreator ? "Yes" : "No"}
                  </TableCell>
                  <TableCell className="border-default-200  text-center">
                    {player.resultType
                      ? Common.Utility.getKeyByValue(
                        MatchResultTypeEnum,
                        player.resultType
                      )
                      : "-"}
                  </TableCell>
                  <TableCell className="border-default-200 text-center">
                    {player.beforePlayedLevel ?? "-"}
                  </TableCell>
                  <TableCell className="border-default-200 text-center">
                    {player.afterPlayedLevel ?? "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <br />
        <div className="overflow-x-auto mt-5">
          <p className="font-bold text-center text-xl">Payment Details</p>
          <Table>
            <TableHeader>
              <TableRow className="whitespace-nowrap">
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Player
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Payment Type
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Account Name
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Payment Status
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Amount
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Is By Club
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  POS Machine
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Receipt
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Action
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className="[&_tr:last-child]:border-1">
              {booking?.transactionLogs?.filter(x => x.transactionType != TransactionLogTypeEnum.PromoCode_Redeemed && x.transactionType != TransactionLogTypeEnum.Club_Discount && x.transactionType != TransactionLogTypeEnum.Bank_Discount).length > 0 ? (
                booking?.transactionLogs
                  ?.filter(x => x.transactionType != TransactionLogTypeEnum.PromoCode_Redeemed && x.transactionType != TransactionLogTypeEnum.Club_Discount && x.transactionType != TransactionLogTypeEnum.Bank_Discount)
                  ?.map((tlog, index) => (
                    <TableRow key={index}>
                      <TableCell className="border-r text-center border-default-200">
                        {tlog.playerName}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog?.paymentTypeName || "-"}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog?.clubAccountName || "-"}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {Common.Utility.getKeyByValue(
                          TransactionLogStatusEnum,
                          tlog.status
                        )}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog.amount}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog.isByClub ? "Yes" : "No"}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog?.posMachineName || "-"}
                      </TableCell>

                      <TableCell className="border-r border-default-200 text-center">
                        {tlog.attachment ? (
                          <div className="relative inline-block">
                            <img
                              src={Common.Utility.getImagePath(tlog.attachment)}
                              alt="Attachment"
                              className="cursor-pointer rounded border"
                              style={{ width: "50px", height: "50px" }}
                              onClick={() => handleImageClick(tlog.attachment)}
                            />
                            <FaRedo
                              className="absolute -top-1 -right-1 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
                              onClick={() => handleOpenPaymentUpdateReceipt(tlog)}
                            />
                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell className="border-r border-default-200 text-center">
                        {tlog.attachmenthistorylogs?.length > 0 ? (
                          <div className="flex items-center justify-center gap-2">

                            <FaEye
                              className="text-blue-500 cursor-pointer ml-2"
                              onClick={() => {
                                handleSeeLog(tlog)
                              }}
                            />

                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className="text-center">
                    No payment received
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </div>


        {booking?.transactionLogs?.length > 0 &&

          (<div className="overflow-x-auto mt-5">
            <p className="font-bold text-center text-xl">Discount </p>
            <Table>
              <TableHeader>
                <TableRow className="whitespace-nowrap">
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Add By
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Type
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Promo Code
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Discount
                  </TableHead>
                  {/* <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Amt
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Avail
                  </TableHead> */}
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Capped
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    POS Machine
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Receipt
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Action
                  </TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className="[&_tr:last-child]:border-1">
                {booking?.transactionLogs?.filter(x => x.transactionType == TransactionLogTypeEnum.PromoCode_Redeemed || x.transactionType == TransactionLogTypeEnum.Club_Discount || x.transactionType == TransactionLogTypeEnum.Bank_Discount).length > 0 ? (
                  booking?.transactionLogs
                    ?.filter(x => x.transactionType == TransactionLogTypeEnum.PromoCode_Redeemed || x.transactionType == TransactionLogTypeEnum.Club_Discount || x.transactionType == TransactionLogTypeEnum.Bank_Discount)
                    ?.map((tlog, index) => (
                      <TableRow key={index}>
                        <TableCell className="border-r text-center border-default-200">
                          {tlog.createdByName || tlog.playerName}
                        </TableCell>

                        <TableCell className="border-r text-center border-default-200">

                          {Common.Utility.getKeyByValue(
                            TransactionLogTypeEnum,
                            tlog.transactionType
                          )}
                        </TableCell>


                        <TableCell className="border-r border-default-200 text-center">
                          {tlog?.promocode || "-"}
                        </TableCell>

                        <TableCell className="border-r border-default-200 text-center">
                          {tlog?.promocodeAmt || "-"}
                        </TableCell>

                        {/* <TableCell className="border-r border-default-200 text-center">
                          {tlog?.orderAmount || "-"}
                        </TableCell>

                        <TableCell className="border-r border-default-200 text-center">
                          {tlog.redeemPercent} %
                        </TableCell> */}

                        <TableCell className="border-r border-default-200 text-center">
                          {tlog.isCapped ? "Yes" : "No"}
                        </TableCell>

                        <TableCell className="border-r border-default-200 text-center">
                          {tlog?.posMachineName || "-"}
                        </TableCell>

                        <TableCell className="border-r border-default-200 text-center">
                          {tlog.attachment ? (
                            <div className="relative inline-block">
                              <img
                                src={Common.Utility.getImagePath(tlog.attachment)}
                                alt="Attachment"
                                className="cursor-pointer rounded border"
                                style={{ width: "50px", height: "50px" }}
                                onClick={() => handleImageClick(tlog.attachment)}
                              />
                              <FaRedo
                                className="absolute -top-1 -right-1 text-blue-500 cursor-pointer bg-white rounded-full shadow-md hover:bg-blue-50 transition-colors receipt-reupload-icon"
                                onClick={() => handleOpenDiscountUpdateReceipt(tlog)}
                              />
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell className="border-r border-default-200 text-center">
                          {tlog.attachmenthistorylogs?.length > 0 ? (
                            <div className="flex items-center justify-center gap-2">

                              <FaEye
                                className="text-blue-500 cursor-pointer ml-2"
                                onClick={() => {
                                  handleSeeLog(tlog)
                                }}
                              />

                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>

                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} className="text-center">
                      No payment received
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>
          </div>)

        }


        <br />
        <div className="overflow-x-auto mt-5">
          <p className="font-bold text-center text-xl">Score Board</p>
          <Table>
            <TableHeader>
              <TableRow className="whitespace-nowrap">
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Side
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Set 1
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Set 2
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Set 3
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className="[&_tr:last-child]:border-1">
              {booking?.groupedResults &&
                Object.keys(booking.groupedResults).length > 0 ? (
                Object.entries(booking.groupedResults).map(
                  ([side, results], index) => {
                    // Initialize sets
                    const sets = { set1: "-", set2: "-", set3: "-" };

                    // Map results to the correct set based on the round
                    results.forEach((result) => {
                      if (result.round === 1) sets.set1 = result.points;
                      if (result.round === 2) sets.set2 = result.points;
                      if (result.round === 3) sets.set3 = result.points;
                    });

                    return (
                      <TableRow key={index}>
                        <TableCell className="border-r text-center border-default-200">
                          {side}
                        </TableCell>
                        <TableCell className="border-r border-default-200 text-center">
                          {sets.set1}
                        </TableCell>
                        <TableCell className="border-r border-default-200 text-center">
                          {sets.set2}
                        </TableCell>
                        <TableCell className="border-r border-default-200 text-center">
                          {sets.set3}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="text-center">
                    Result not uploaded
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {booking?.notes && (
          <>
            <br />
            <div className="overflow-x-auto mt-5">
              <p className="font-bold text-center text-xl">Note</p>
              <hr className="border-default-200" />
              <Table>
                <TableBody className="[&_tr:last-child]:border-1">
                  <TableRow>
                    <TableCell className="border-r text-center border-default-200">
                      {booking.notes}
                    </TableCell>
                    <TableCell className="border-r text-center border-default-200 w-10 whitespace-nowrap">
                      <button className="p-1 hover:text-blue-700" onClick={() => setShowNotes(true)}>
                        <Icon icon="heroicons:pencil" className="w-4 h-4 text-blue-500" />
                      </button>
                    </TableCell>


                  </TableRow>
                </TableBody>
              </Table>
            </div>

            <br />

            
          </>
        )}

        <br />
        <div className="overflow-x-auto mt-5">
          <p className="font-bold text-center text-xl">Reschedule Details</p>
          <Table>
            <TableHeader>
              <TableRow className="whitespace-nowrap">
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Court Name
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Previous Start time
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Previous End time
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  New Start time
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  New End time
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Court Changed
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className="[&_tr:last-child]:border-1">
              {booking?.reschedulings?.length > 0 ? (
                booking.reschedulings.map((resc, index) => (
                  <TableRow key={index}>
                    <TableCell className="border-r text-center border-default-200">
                      {resc.courtName}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {resc?.previousStartDateTime
                        ? dayjs(resc.previousStartDateTime).format(
                          DateTimeFormat
                        )
                        : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {resc?.previousEndDateTime
                        ? dayjs(resc.previousEndDateTime).format(DateTimeFormat)
                        : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {resc?.newStartDateTime
                        ? dayjs(resc.newStartDateTime).format(DateTimeFormat)
                        : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {resc?.newEndDateTime
                        ? dayjs(resc.newEndDateTime).format(DateTimeFormat)
                        : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {resc.isCourtChanged ? "Yes" : "No"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="text-center">
                    No Booking Reschedule
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        <br />
        

          {booking?.taxlogs?.length > 0 && (
        <div className="overflow-x-auto mt-5">
          <p className="font-bold text-center text-xl">Tax Details</p>
          <Table>
            <TableHeader>
              <TableRow className="whitespace-nowrap">
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Type
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Percentage
                </TableHead>
                <TableHead className="text-sm text-default-800 border-default-200 text-center">
                  Amount
                </TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className="[&_tr:last-child]:border-1">
              {booking?.taxlogs?.length > 0 ? (
                booking.taxlogs.map((tax, index) => (
                  <TableRow key={index}>
                    <TableCell className="border-r border-default-200 text-center">
                      {tax.type
                        ? Common.Utility.getKeyByValue(
                            TaxTypeEnum,
                            tax.type
                          )
                        : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {tax.percentage ? `${tax.percentage}%` : "-"}
                    </TableCell>

                    <TableCell className="border-r border-default-200 text-center">
                      {tax.amount || "-"}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="text-center">
                    No tax details
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        )}


        {booking?.changeplayerlogs?.length > 0 && (
          <div className="overflow-x-auto mt-5">
            <p className="font-bold text-center text-xl">Change Player Logs</p>
            <Table>
              <TableHeader>
                <TableRow className="whitespace-nowrap">
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Old Player
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    New Player
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Changed At
                  </TableHead>
                  <TableHead className="text-sm text-default-800 border-default-200 text-center">
                    Changed By
                  </TableHead>
                </TableRow>
              </TableHeader>

              <TableBody className="[&_tr:last-child]:border-1">
                {booking.changeplayerlogs.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell className="border-r border-default-200 text-center">
                      {log.old_player}
                    </TableCell>
                    <TableCell className="border-r border-default-200 text-center">
                      {log.new_player}
                    </TableCell>
                    <TableCell className="border-r border-default-200 text-center">
                      {/* {Common.Utility.ConvertDate(log.createdon).format(ViewDateTimeFormat)} */}

                      {moment(Common.Utility.ConvertTime(log.created_on)).format(ViewDateTimeFormat)}
                    </TableCell>
                    <TableCell className="border-r border-default-200 text-center">
                      {log.created_by_name}
                    </TableCell>
                  </TableRow>
                ))
                }
              </TableBody>
            </Table>
          </div>
        )}


        {/* Receipt View Modal   */}
        {isModalOpenForReceipt && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-5 rounded-lg shadow-lg relative max-w-3xl w-[90%] h-auto">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              >
                <Icon icon="heroicons:x-mark" className="w-6 h-6" />
              </button>
              <h2 className="text-lg font-bold mb-4 text-center">Receipt Image</h2>
              <div className="flex justify-center items-center min-h-[200px]">
                {modalContent && (
                  <img
                    src={modalContent.props.src}
                    alt="Receipt"
                    className="max-w-full max-h-[70vh] object-contain rounded-lg"
                    style={{ margin: 'auto' }}
                  />
                )}
              </div>
            </div>
          </div>
        )}


      {/* Receipt View Modal   */}
        {isModalOpenForPlayer && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-5 rounded-lg shadow-lg relative max-w-3xl w-[90%] h-auto">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              >
                <Icon icon="heroicons:x-mark" className="w-6 h-6" />
              </button>
              <h2 className="text-lg font-bold mb-4 text-center">Player Image</h2>
              <div className="flex justify-center items-center min-h-[200px]">
                {modalContent && (
                  <img
                    src={modalContent.props.src}
                    alt="Player Image"
                    className="max-w-full max-h-[70vh] object-contain rounded-lg"
                    style={{ margin: 'auto' }}
                  />
                )}
              </div>
            </div>
          </div>
        )}


        {/* DialogModal for updating receipt */}
        {showUpdateReceipt && (
          <DialogModal
            title={
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <Icon
                    icon="heroicons:document-arrow-up"
                    className="w-5 h-5 text-blue-600"
                  />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Change Receipt</h3>
                  {/* <p className="text-gray-600 text-sm">
                    Upload new receipt or change existing one
                  </p> */}
                </div>
              </div>
            }
            open={showUpdateReceipt}
            setOpen={setShowUpdateReceipt}
            Child={() =>
              _renderUpdateReceipt({
                ...updateReceiptData,
                onClose: () => setShowUpdateReceipt(false),
              })
            }
            className="max-w-2xl"
          />
        )}

        {/* Modal for seeing log */}
        {showLogModal && (
          <DialogModal
            open={showLogModal}
            setOpen={setShowLogModal}
            Child={() =>
              _renderViewLogs({
                logs: selectedLog?.attachmenthistorylogs || [],
                onClose: () => setShowLogModal(false),
              })
            }
            className="!max-w-6xl w-[90vw] max-h-[90vh]"
          />
        )}
      </CardContent>
    </div>
  );
};

export default BooingFurthurDetails;

